module.exports = __webpack_public_path__ + "static/media/yourlogohere.4bd32c0d.png";